import { messagesInbox as TYPES } from './../action_types';
import { MessageThreadsService } from './services.wjs.jsx';

export function fetchMessageThreads() {
  return (dispatch, getState) => {
    const { MessagesInbox } = getState();
    const { exhausted, fetching, cursor } = MessagesInbox.meta;

    if (exhausted || fetching) return;

    dispatch({ type: TYPES.FETCH_MESSAGE_THREADS_REQUEST });

    // services
    MessageThreadsService(cursor ? { cursor } : {}).done((res) => {
      dispatch({
        type: TYPES.FETCH_MESSAGE_THREADS_SUCCESS,
        messageThreads: res.message_threads,
        cursor: res.cursor,
        exhausted: res.exhausted,
      });
    });
  };
}

export function markMessageThreadAsRead(messageThreadId) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch, getState) {
    $.ajax({
      type: 'POST',
      url: $r.mark_as_read_api_v0_message_thread_path({
        subdomain_param: 'api',
        id: messageThreadId,
      }),
    })
      .success(function () {
        dispatch({
          type: TYPES.MARK_MESSAGE_THREAD_AS_READ,
          messageThread: {
            id: messageThreadId,
          },
        });
      })
      .fail(function () {
        alert('Something went wrong!');
      });
  };
}

export function markMessageThreadAsSpam(messageThreadId) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch, getState) {
    $.ajax({
      type: 'POST',
      url: $r.mark_as_spam_api_v0_message_thread_path({
        subdomain_param: 'api',
        id: messageThreadId,
      }),
    })
      .success(function () {
        dispatch({
          type: TYPES.REMOVE_MESSAGE_THREAD,
          messageThread: {
            id: messageThreadId,
          },
        });
        Components.Utils.showToast(Components.Toasts.BasicToast, {
          text: 'Conversation marked as spam',
        });
      })
      .fail(function () {
        alert('Something went wrong!');
      });
  };
}

export function deleteMessageThread(messageThreadId) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch, getState) {
    $.ajax({
      type: 'DELETE',
      url: $r.api_v0_message_thread_path({
        subdomain_param: 'api',
        id: messageThreadId,
      }),
    })
      .success(function () {
        dispatch({
          type: TYPES.REMOVE_MESSAGE_THREAD,
          messageThread: {
            id: messageThreadId,
          },
        });
        Components.Utils.showToast(Components.Toasts.BasicToast, {
          text: 'Conversation deleted',
        });
      })
      .fail(function () {
        alert('Something went wrong!');
      });
  };
}

export function sendMessage(messageThreadId, messageBody) {
  return function (dispatch, getState) {
    if (getState().MessagesInbox.meta.sending) return;
    const message = {
      body: messageBody,
      sender_id: Aedu.User.current.id,
      message_thread_id: messageThreadId,
    };
    dispatch({
      type: TYPES.SEND_MESSAGE_REQUEST,
    });
    $.ajax({
      type: 'POST',
      url: $r.api_v0_messages_path({
        subdomain_param: 'api',
      }),
      data: {
        message: message,
      },
    })
      .success(function (res) {
        dispatch({
          type: TYPES.ADD_MESSAGE_TO_THREAD,
          messageThread: {
            id: messageThreadId,
            newMessage: res.message,
          },
        });
        Components.Utils.showToast(Components.Toasts.BasicToast, {
          text: 'Message Sent',
        });
      })
      .fail(function (xhr) {
        let errorMessage = `Sorry, an error occurred. Please try again.`;

        if (xhr.status === 422) {
          try {
            const response = JSON.parse(xhr.responseText);
            const errors = Object.values(response.errors).flat();
            if (errors[0]) {
              errorMessage = errors[0];
            }
          } catch {
            // Use default error message if JSON parsing fails
          }
        }

        dispatch({
          type: TYPES.SEND_MESSAGE_FAILURE,
          error: errorMessage,
        });
      });
  };
}

export function clearSendingError() {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch, getState) {
    dispatch({
      type: TYPES.CLEAR_SENDING_ERROR,
    });
  };
}

export function setReplyValue(messageThreadId, replyValue) {
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return function (dispatch, getState) {
    dispatch({
      type: TYPES.SET_REPLY_VALUE,
      messageThread: {
        id: messageThreadId,
        replyValue: replyValue,
      },
    });
  };
}
